import { z } from 'zod';
import { idSchema } from './common.js';

export const feedbackRequestSchema = z.strictObject({
  galaxyId: idSchema.optional(),
  /** The client route the tester was on. */
  screen: z.string().min(1).max(200),
  message: z.string().trim().min(1).max(2000),
});
export type FeedbackRequest = z.infer<typeof feedbackRequestSchema>;

export const feedbackResponseSchema = z.strictObject({ feedbackId: idSchema });
export type FeedbackResponse = z.infer<typeof feedbackResponseSchema>;
